(function () {
    'use strict';
    var controllerId = 'cndAdesioni';
    angular.module('app').controller(controllerId, ['common', 'bootstrap.dialog', '$routeParams', '$uibModal', 'datacontext', 'sectionMenu', 'filterFilter', fn_cndAdesioni]);

    function fn_cndAdesioni(common, bDialog, $routeParams, modal, datacontext, sectionMenu, filterFilter) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);
        var logError = getLogFn(controllerId, 'logError');
        var logSuccess = getLogFn(controllerId, 'logSuccess');


        var vm = this;
        vm.title = 'adesioni';
        vm.view = 'detail';       //Opzione list or detail
        vm.setView = setView;
        vm.sectionMenu = sectionMenu.setSection(vm.title);

        vm.objName = "adesione"; //Utilizzato per pannello authorization		
        vm.authorization = {};
        vm.showObjPanel = false;
        vm.record = {};
        vm.records = [];
        vm.countRecords = 0;
        vm.index = 0;
        vm.custom = false;
        vm.showInfoMsg = true;
        vm.setShowInfoMsg = setShowInfoMsg;
        vm.ableMenu = true;
        vm.classStep = [];
        vm.classStepIcon = [];
        vm.classStepComplete = [];
        vm.stepEdit = [];
        vm.stepCompleted = [];
        vm.maxStep = 3;
        vm.errorAccess = '';
        vm.tSourceCode_ADES = 'ADES';
        vm.isVisibleLinkDomanda = false;
        vm.showReq = false;

        //Pannelli dei dati (viewAdes)
        vm.showPanelAdes1 = true;
        vm.showPanelAdes2 = true;
        vm.showPanelAdes3 = true;
        vm.showPanelAdes4 = true;
        vm.showPanelAdes5 = true;
        vm.setShowPanelAdes1 = setShowPanelAdes1;
        vm.setShowPanelAdes2 = setShowPanelAdes2;
        vm.setShowPanelAdes3 = setShowPanelAdes3;
        vm.setShowPanelAdes4 = setShowPanelAdes4;
        vm.setShowPanelAdes5 = setShowPanelAdes5;

        //Pannelli dei dati (viewAtt)
        vm.showPanelAtt1 = true;
        vm.showPanelAtt2 = true;
        vm.showPanelAtt3 = true;
        vm.setShowPanelAtt1 = setShowPanelAtt1;
        vm.setShowPanelAtt2 = setShowPanelAtt2;
        vm.setShowPanelAtt3 = setShowPanelAtt3;

        //Pannelli dei dati (viewRiep)
        vm.showPanelRiep1 = true;
        vm.setShowPanelRiep1 = setShowPanelRiep1;


        vm.addDisabled = false;
        vm.exportDisabled = false;
        vm.pageSize = 30;
        vm.page = 1;
        vm.loading = false;

        vm.cndProgetto = {};
        vm.urlRoot = datacontext.adesione_getURL();


        //Elenco per Ordinamento
        vm.list = {};
        vm.list.ordine = ['Nominativo', 'Codice Fiscale'];
        vm.ordine = vm.list.ordine[0];
        vm.selectOrdine = function (item) {
            vm.ordine = item;
        };

        //Elenchi dettaglio
        vm.list.attach = [];
        vm.list.pSedi = [];
        vm.list.b_attach = false;


        //vm.getRecord = getRecord;
        //vm.getListAttach = getListAttach;

        //Conteggio Elenchi
        vm.countAttachProfilo = function () {
            var filter = {};
            return filterFilter(vm.list.attach, filter).length;
        }

        //vm.saveAll = saveAll;

        //Attach 2
        vm.tAttach_Needed = [];
        vm.list.attach_ades = [];
        vm.addAttach = addAttach;
        vm.getListAttach = getListAttach;
        vm.disableCompleted = true;
        vm.deleteAttach = deleteAttach;
        vm.extractP7MFile = getExtractP7MFile;
        vm.extractP7MInfo = getExtractP7MInfo;
        vm.populateAttach = populateAttach;




        //Filtro
        vm.fTestuale = '';

        vm.fAttach = {};
        vm.setfAttach = setfAttach;

        //Elenchi per filtri e finestra modale di Create
        vm.cmblist = {};
        vm.cmblist.cpi = [];
        vm.cmblist.paesi = [];
        vm.cmblist.province = [];
        vm.cmblist.tIndirizzi = [];
        vm.cmblist.cittadinanze = [];
        vm.cmblist.comuniNasc = [];
        vm.cmblist.comuniRes = [];
        vm.cmblist.comuniDom = [];

        vm.cmblist.mesi = datacontext.arrMesi();
        vm.cmblist.partecipazioni = [];

        vm.tSource = {};
        vm.tAttach = [];
        vm.tAttach_Needed = [];


        //Metodi su interfaccia
        vm.activated = false;
        //vm.addAttach = addAttach;
        //vm.deleteAttach = deleteAttach;

        //DA
        vm.setStep = setStep;
        vm.changeStatus = changeStatus;
        vm.printRicevuta = printRicevuta;
        vm.printAll = printAll;

        //Gestione conferma input di tipo Email
        vm.confirm = {};


        //vm.get = getRecord;
        vm.add = addModal;
        vm.saveAdes = saveOrUpdateItem;
        vm.delete = deleteItem;

        vm.changePaese = changePaese;
        vm.changeProvincia = changeProvincia;
        vm.changeComune = changeComune;
        vm.changeDomUgualeRes = changeDomUgualeRes;
        vm.changeIscrittoCPI = changeIscrittoCPI;
        vm.changePartecipazione = changePartecipazione;
        vm.getAllPSede = getAllPSede;

        vm.prevStep = prevStep;
        vm.nextStep = nextStep;

        vm.isVisiblePrevButton = isVisiblePrevButton;
        vm.isVisibleNextButton = isVisibleNextButton;
        vm.isVisibleSaveButton = isVisibleSaveButton;

        vm.isAblePrevButton = isAblePrevButton;
        vm.isAbleNextButton = isAbleNextButton;
        vm.isAbleSaveButton = isAbleSaveButton;
        vm.isAbleAddButton = isAbleAddButton;


        //datapicker
        vm.open = function ($event, iOpened) {
            $event.preventDefault();
            $event.stopPropagation();

            vm.opened1 = false;
            vm.opened2 = false;
            vm.opened3 = false;
            if (iOpened == 1)
                vm.opened1 = true;
            else if (iOpened == 2)
                vm.opened2 = true;
            else if (iOpened == 3)
                vm.opened3 = true;
        };

        vm.clear = function ($event, iOpened) {
            if (iOpened == 1) {
                vm.record.NascData = '';
                vm.changed = true;
            } else if (iOpened == 2) {
                vm.record.DtIscrittoCPI = '';
                vm.changed = true;
            } else if (iOpened == 3) {
                vm.record.DtPdS = '';
                vm.changed = true;
            }
        };

        vm.dateOptions = {
            formatYear: 'yyyy',
            formatMonth: 'MM',
            startingDay: 1
        };

        vm.format = 'dd/MM/yyyy';

        // ---- ACTIVATE -------
        loadStepParams();
        activate();

        function activate() {
            if ($routeParams.projectUID != null) {
                return getCNDProgetto($routeParams.projectUID).then(function () {
                    if ($routeParams.adesioneUID != null) {
                        return getRecordByUID($routeParams.adesioneUID).then(function () {
                            console.info('vm.record', vm.record);
                            if (!vm.record.Completed) {
                                var promises = [
                                    getTSource(vm.tSourceCode_ADES)
                                    , getCPI()
                                    , getAllPartecipazioni()
                                    , getPaesi()
                                    , getProvince()
                                    , getTIndirizzi()
                                    , getCittadinanze()
                                ];
                                return common.activateController(promises, controllerId)
                                    .then(function () {
                                        return true;
                                    });
                            }
                            else if (!vm.record.AttachChecked) {
                                var promises1 = [
                                    getTSource(vm.tSourceCode_ADES)
                                    , getCPI()
                                    , getAllPartecipazioni()
                                    , getPaesi()
                                    , getProvince()
                                    , getTIndirizzi()
                                    , getCittadinanze()
                                ];
                                return common.activateController(promises1, controllerId)
                                    .then(function () {
                                        return true;
                                    });
                            }
                        });
                    }
                    else {
                        vm.record.Id = 0;
                        vm.record.PartecipazioneId = 0;
                        vm.record.PSedeId = 0;
                        vm.record.SoggettoCode = '';
                        vm.record.SoggettoId = 0;
                        vm.record.Soggetto = '';
                        vm.record.SoggettoCF = '';
                        vm.record.NascPaeseId = 0; //ITALIA
                        vm.record.ResPaeseId = 0; //ITALIA
                        vm.record.DomUgualeRes = 0;
                        vm.record.ResTIndirizzoId = 1;
                        vm.record.Cittadinanza1Id = 1; //ITALIA
                        vm.record.CPIId = 0;
                        vm.confirm.Email = '';
                        vm.record.bP4 = false;
                        vm.record.Dich2_03 = false;
                        vm.ddChecked = false;
                        checkCF(vm.record.CodiceFiscale);

                        var promises = [
                            getTSource(vm.tSourceCode_ADES)
                            , getCPI()
                            , getAllPartecipazioni()
                            , getPaesi()
                            , getProvince()
                            , getTIndirizzi()
                            , getCittadinanze()
                        ];
                        return common.activateController(promises, controllerId)
                            .then(function () {
                                return setStep(0);
                            });
                    }

                });
            }
        }


        //****************************************************
        // METODI 
        //****************************************************
        function setView(view) {
            return vm.view = view;
        }

        function nextStep() {
            if (vm.actualStep == 0 &&
                (!vm.record.Dich1_00 && !vm.record.Dich1_01 && !vm.record.Dich1_02 && !vm.record.Dich1_03 && !vm.record.Dich1_04
                    && !vm.record.Dich1_05 && !vm.record.Dich1_06 && !vm.record.Dich1_07 && !vm.record.Dich1_08
                ||
                !vm.record.TStudio_00 && !vm.record.TStudio_01 && !vm.record.TStudio_02 && !vm.record.TStudio_03 && !vm.record.TStudio_04
                && !vm.record.TStudio_05 && !vm.record.TStudio_06 && !vm.record.TStudio_07 && !vm.record.TStudio_08 && !vm.record.TStudio_09
            )
            ) {
                return bDialog.informationDialog('Attenzione: bisogna indicare un titolo di studio e/o la situazine del beneficiario nella sezione 4 Dichiarazioni');
            }

            bDialog.confirmationDialog('Attenzione', 'Si sta passando alla Fase successiva, se le modifiche NON sono state salvate con apposito tasto "SALVA", andranno perse. Procedere? ', 'SI').then(
                function () { //YES
                    setStep(vm.actualStep + 1);
                },
                function () { //NO
                    //
                }
            );
        }

        function prevStep() {
            setStep(vm.actualStep - 1);
        }

        function loadStepParams() {
            vm.labelsStep = [];
            vm.titlesStep = [];
            vm.subtitlesStep = [];
            vm.descriptionsStep = [];

            vm.labelsStep[0] = "A";
            vm.titlesStep[0] = "Fase A";
            vm.subtitlesStep[0] = "Domanda di iscrizione";
            vm.descriptionsStep[0] = "&Egrave; richiesto l'inserimento dei dati necessari alla compilazione della 'Domanda di iscrizione agli interventi formativi Percorso 4 GOL'.<br/>&Egrave; possibile procedere alla fase successiva solo dopo aver inserito e salvato tutte le informazioni richieste in questa fase.<br/>&Egrave; consigliato generare la bozza dell\'allegato 2 - Domanda di iscrizione, per appurare la bont&agrave; dei dati imputati.";

            vm.labelsStep[1] = "B";
            vm.titlesStep[1] = "Fase B";
            vm.subtitlesStep[1] = "Upload Documentale";
            vm.descriptionsStep[1] = "&Egrave; richiesta la convalida dei dati, si ricorda che la convalida non consente ulteriori variazioni.<br />Effettuata la convalida, occore scaricare l'allegato generato dal portale, firmarlo e ricaricarlo unitamente all'altra documentazione richiesta, compilando integralmente l'elenco.";

            vm.labelsStep[2] = "C";
            vm.titlesStep[2] = "Fase C";
            vm.subtitlesStep[2] = "Stampa ricevuta";
            vm.descriptionsStep[2] = "&Egrave; possibile stampare la 'Ricevuta di iscrizione' contenente il codice univoco di identificazione della pratica.";
        }

        function setStepDefault() {
            if (vm.record.AttachChecked) {
                setStep(2);
            } else if (vm.record.Completed) {
                setStep(1);
            } else {
                setStep(0);
            }
        }

        function setStep(actualStep) {

            if (actualStep >= vm.maxStep)
                actualStep = vm.maxStep - 1;

            if (actualStep < 0)
                actualStep = 0;

            vm.actualStep = actualStep;
            switch (vm.actualStep) {
                case 0:
                    setView('viewAdes');
                    break;
                case 1:
                    populateAttach();
                    setView('viewAtt');
                    break;
                case 2:
                    setView('viewRiep');
                    break;
            }

            vm.labelStep = vm.labelsStep[vm.actualStep];
            vm.titleStep = vm.titlesStep[vm.actualStep];
            vm.subtitleStep = vm.subtitlesStep[vm.actualStep];
            vm.descriptionStep = vm.descriptionsStep[vm.actualStep];
            setClassSeqWiz();

        }


        function setClassSeqWiz() {
            vm.classStep = [];
            vm.classStepIcon = [];
            vm.classStepComplete = [];
            vm.stepEdit = [];
            vm.stepCompleted = [];


            var cssEdit = 'blue';
            var cssCompleted = 'green';
            var cssDefault = 'gray';
            var cssLast = 'last';

            var faIconEdit = 'fa fa-pencil';
            var faIconComplete = 'fa fa-check';
            var faIconDefault = '';

            var cssStepComplete = 'step-complete';

            var spanEdit = 'span-select';
            var spanDefault = '';

            vm.stepEdit[vm.actualStep] = true;
            vm.stepCompleted[0] = (vm.record != undefined && vm.record.Completed);
            vm.stepCompleted[1] = (vm.record != undefined && vm.record.AttachChecked);
            vm.stepCompleted[2] = (vm.record != undefined && vm.record.Sent);

            for (var i = 0; i < vm.maxStep; i++) {

                //Seconda Gestione
                //CLASS STEP
                vm.classStep[i] = '';
                if (vm.stepEdit[i]) // se � in edit
                    vm.classStep[i] = cssEdit;
                else // altrimenti
                    vm.classStep[i] = cssDefault;

                if (i + 1 == vm.maxStep) // se sono nell'ultima fase
                    vm.classStep[i] = cssLast + '-' + vm.classStep[i];
                else if (vm.stepEdit[i + 1]) // se � in edit
                    vm.classStep[i] = vm.classStep[i] + '-' + cssEdit;
                else // altrimenti
                    vm.classStep[i] = vm.classStep[i] + '-' + cssDefault;


                //ICON STEP
                vm.classStepIcon[i] = '';
                if (vm.stepCompleted[i]) // se � completed
                    vm.classStepIcon[i] = faIconComplete;
                else if (vm.stepEdit[i]) // se � in edit
                    vm.classStepIcon[i] = faIconEdit;

                //ICON STEP COMPLETE
                vm.classStepComplete[i] = '';
                if (vm.stepCompleted[i] && !vm.stepEdit[i]) // se � completed
                    vm.classStepComplete[i] = cssStepComplete;
            }
        }

        function isAblePrevButton() {
            //Inserire qui i casi in cui non � abilitata la fase successiva
            return vm.actualStep > 0;
        }
        function isAbleNextButton() {
            var able = false;
            //Inserire qui i casi in cui non � abilitata la fase successiva
            switch (vm.view) {
                case 'viewAdes':
                    if (vm.record.Id > 0)
                        able = true;
                    break;
                case 'viewAtt':
                    if (vm.record != undefined && vm.record.Completed)
                        able = true;
                    break;
            }

            return vm.actualStep < (vm.maxStep - 1) && able;
        }

        function isAbleSaveButton() {
            var disable = false;

            //console.info('form', vm.view, form.$pristine, form.$invalid, vm.loading, form);
            //disable = form.$pristine || form.$invalid || vm.loading;
            switch (vm.actualStep) {
                case 0:
                    //Inserire qui i casi in cui non � abilitato il tasto salva
                    disable = vm.loading || vm.record.Completed || !vm.record.Dlgs196
                        || !vm.validFieldsCF || !vm.validCF || vm.existCF || (!vm.ddChecked && !vm.record.bP4 && !vm.record.Dich2_03)
                        || (vm.record.Email != undefined && vm.record.Email.toLowerCase() != vm.confirm.Email.toLowerCase());
                    break;
                case 1:
                    //Inserire qui i casi in cui non � abilitato il tasto salva
                    break;
                case 2:
                    //Inserire qui i casi in cui non � abilitato il tasto salva
                    break;
            }

            return !disable;
        }
        function isAbleAddButton() {
            var disable = false;
            var form = document.forms[vm.view];
            //console.info('form', vm.view, form.$pristine, form.$invalid, vm.loading, form);
            //disable = form.$pristine || form.$invalid

            switch (vm.actualStep) {
                case 0:
                    //Inserire qui i casi in cui non � abilitato il tasto Add
                    break;
                case 1:
                    //Inserire qui i casi in cui non � abilitato il tasto Add
                    break;
                case 2:
                    //Inserire qui i casi in cui non � abilitato il tasto Add
                    break;
                case 3:
                    //Inserire qui i casi in cui non � abilitato il tasto Add
                    break;
                case 4:
                    //Inserire qui i casi in cui non � abilitato il tasto Add
                    break;
            }

            return !disable;
        }

        function isVisiblePrevButton() {
            return true;
        }
        function isVisibleNextButton() {
            return true;
        }
        function isVisibleSaveButton() {
            return true;
        }


        function setShowInfoMsg() {
            return vm.showInfoMsg = !vm.showInfoMsg;
        }
        //Gestione per viewAdes
        function setShowPanelAdes1() {
            return vm.showPanelAdes1 = !vm.showPanelAdes1;
        }
        function setShowPanelAdes2() {
            return vm.showPanelAdes2 = !vm.showPanelAdes2;
        }
        function setShowPanelAdes3() {
            return vm.showPanelAdes3 = !vm.showPanelAdes3;
        }
        function setShowPanelAdes4() {
            return vm.showPanelAdes4 = !vm.showPanelAdes4;
        }
        function setShowPanelAdes5() {
            return vm.showPanelAdes5 = !vm.showPanelAdes5;
        }
        //Gestione per viewAtt
        function setShowPanelAtt1() {
            return vm.showPanelAtt1 = !vm.showPanelAtt1;
        }
        function setShowPanelAtt2() {
            return vm.showPanelAtt2 = !vm.showPanelAtt2;
        }
        function setShowPanelAtt3() {
            return vm.showPanelAtt3 = !vm.showPanelAtt3;
        }
        //Gestione per viewRiep
        function setShowPanelRiep1() {
            return vm.showPanelRiep1 = !vm.showPanelRiep1;
        }


        function getCNDProgetto(cndProgettoUID) {
            console.info('getCNDProgetto', cndProgettoUID);
            return datacontext.cndProgetto_getByUID(cndProgettoUID)
                .then(function (data) {
                    console.info('data', data);
                    if (data.UID != cndProgettoUID) {
                        vm.cndProgetto = {};
                        showAlertDivs('linkError');
                    } else { //Codice Progetto corretto
                        vm.cndProgetto = data;

                        var dt = new Date();
                        var dtStart = new Date(vm.cndProgetto.DtStart);
                        var dtEnd = new Date(vm.cndProgetto.DtEnd);

                        vm.ore_disp = moment(dtEnd).format('LT');
                        //if (vm.ore_disp == "00:00") vm.ore_disp = "24:00";
                        if (vm.ore_disp == "23:59") vm.ore_disp = "24:00";
                        vm.data_disp = moment(dtEnd).format("DD MMMM YYYY");

                        if (dt < dtStart) {
                            showAlertDivs('enableBeforeStart');
                        } else if (dt > dtEnd) {
                            showAlertDivs('callExpired');
                        } else {
                            showAlertDivs('');
                        }

                        sectionMenu.setUrlLogoHeader(vm.cndProgetto.LogoHeader);
                        sectionMenu.setLnkPDFBando(vm.cndProgetto.LnkPDFBando);
                        sectionMenu.setLnkPDFManuale(vm.cndProgetto.LnkPDFManuale);
                        sectionMenu.setLnkOfficialSite(vm.cndProgetto.LnkOfficialSite);
                        sectionMenu.setTipoCandidatura(vm.cndProgetto.iTipoCandidatura);
                        sectionMenu.setLabelCF('Codice Fiscale');
                        sectionMenu.setProjectUID(vm.cndProgetto.UID);

                        vm.record.ProgettoId = vm.cndProgetto.Id;
                    }

                },
                    //else
                    function (data) {
                        vm.cndProgetto = {};
                        showAlertDivs('linkError');
                    }
                );
        }

        //*************************************
        // Domanda di Adesione

        function changeStatus(action, _item) {
            if (_item == undefined) {
                _item = vm.record;
            }
            var msg = '';
            var itemName = 'la domanda di iscrizione di ' + _item.CodiceFiscale;
            switch (action) {
                case 'completed':
                    msg = 'Stai impostando ' + itemName + ' nello stato "NON MODIFICABILE". Convalidando i dati non sar\xE0 possibile apportare alcuna modifica ai dati inseriti nella \'Fase A\'. Procedere? ';
                    break;
                case 'attached':
                    msg = 'Stai impostando  ' + itemName + ' nello stato "ALLEGATI VERIFICATI". Si sta proseguendo alla "Fase C", pertanto, non sar\xE0 possibile tornare indietro e/o aggiungere, modificare, eliminare gli allegati caricati a sistema. Procedere? ';
                    break;
                case 'sent':
                    msg = 'Stai impostando  ' + itemName + ' nello stato "GENERA RICEVUTA". La stampa della "Ricevuta" equivale a dichiarare terminata tutta la procedura telematica; pertanto non sar\xE0 possibile modificare o caricare altri documenti. Procedere? ';
                    break;
                case 'annulled':
                    msg = 'Stai impostando  ' + itemName + ' nello stato "ANNULLATA". Procedere? ';
                    break;
                case 'not-completed':
                    msg = 'Stai impostando ' + itemName + ' nello stato "IN LAVORAZIONE". Procedere? ';
                    break;
                case 'not-attached':
                    msg = 'Stai impostando  ' + itemName + ' nello stato "ALLEGATI DA VERIFICARE". Procedere? ';
                    break;
                case 'not-sent':
                    msg = 'Stai impostando  ' + itemName + ' nello stato "RIMUOVI RICEVUTA". Procedere? ';
                    break;
                case 'not-annulled':
                    msg = 'Stai impostando  ' + itemName + ' nello stato "NON ANNULLATA". Procedere? ';
                    break;
            }
            bDialog.confirmationDialog('VARIAZIONE STATO', msg, 'OK').then(
                function () { //YES
                    switch (action) {
                        case 'sent':
                            if (!_item.Sent) {
                                fn_changeStatus(action, _item);
                            }
                            else {
                                printRicevuta();
                            }
                            break;
                        case 'attached':
                            if (!_item.AttachChecked) {
                                fn_changeStatus(action, _item);
                            }
                            else {
                                setStep(2);
                            }
                            break;
                        default:
                            fn_changeStatus(action, _item);
                            break;
                    }
                },
                function () { //NO
                    //log('exit');
                }
            );
        }

        function fn_changeStatus(action, item) {
            $('#loadingModal').modal('show');
            return datacontext.cndAdesione_changeStatus(item.Id, action).then(function (data) {
                $('#loadingModal').modal('hide');
                if (data) {
                    console.info('data', data);
                    var status = data.status;
                    if (status != "204") { //Non va a buon fine
                        switch (action) {
                            case 'completed':
                                vm.record.Completed = false;
                                break;
                            case 'attached':
                                vm.record.AttachChecked = false;
                                setStep(1);
                                break;
                            case 'sent':
                                vm.record.Sent = false;
                                break;
                            case 'annulled':
                                vm.record.Annulled = false;
                                break;
                            case 'not-completed':
                                vm.record.Completed = true;
                                break;
                            case 'not-attached':
                                vm.record.AttachChecked = true;
                                break;
                            case 'not-sent':
                                vm.record.Sent = true;
                                break;
                            case 'not-annulled':
                                vm.record.Annulled = true;
                                break;
                        }
                        if (status == "406") return bDialog.errorDialog('Attenzione: bisogna prima inserire tutti gli allegati obbligatori, badando che ciascuna tipologia non ecceda il numero massimo consentito.');
                        if (status == "404") return bDialog.errorDialog('Attenzione: si \xE8 verificato un errore. Contattare il supporto tecnico. ');
                        if (status == "408") return bDialog.errorDialog('Attenzione: si \xE8 verificato un errore. Il sistema sta elaborando molte richieste. Riprova tra qualche istante.. ');

                        return logError('Attenzione si \xE8 verifcato un errore.');
                    }
                }

                switch (action) { //Va a buon fine
                    case 'completed':
                        vm.record.Completed = true;
                        if (vm.records[vm.index]) vm.records[vm.index].Completed = vm.record.Completed;
                        setClassSeqWiz();
                        break;
                    case 'attached':
                        vm.record.AttachChecked = true;
                        if (vm.records[vm.index]) vm.records[vm.index].AttachChecked = vm.record.AttachChecked;
                        setClassSeqWiz();
                        setStep(2);
                        break;
                    case 'sent':
                        vm.record.Sent = true;
                        if (vm.records[vm.index]) vm.records[vm.index].Sent = vm.record.Sent;
                        setClassSeqWiz();
                        printRicevuta();
                        break;
                    case 'annulled':
                        vm.record.Annulled = true;
                        if (vm.records[vm.index]) vm.records[vm.index].Annulled = vm.record.Annulled;
                        break;
                    case 'not-completed':
                        vm.record.Completed = false;
                        if (vm.records[vm.index]) vm.records[vm.index].Completed = vm.record.Completed;
                        break;
                    case 'not-attached':
                        vm.record.AttachChecked = false;
                        if (vm.records[vm.index]) vm.records[vm.index].AttachChecked = vm.record.AttachChecked;
                        break;
                    case 'not-sent':
                        vm.record.Sent = false;
                        if (vm.records[vm.index]) vm.records[vm.index].Sent = vm.record.Sent;
                        break;
                    case 'not-sentumc':
                        vm.record.SentUMC = false;
                        if (vm.records[vm.index]) vm.records[vm.index].SentUMC = vm.record.SentUMC;
                        break;
                    case 'not-annulled':
                        vm.record.Annulled = false;
                        if (vm.records[vm.index]) vm.records[vm.index].Annulled = vm.record.Annulled;
                        break;
                }

                return logSuccess('Record aggiornato');
            });
        }


        //*******************************
        // Print PDF ADESIONE

        function printAll(code) {
            $('#loadingModal').modal('show');
            return datacontext.pdf_printAttach(vm.tSourceCode_ADES, $routeParams.projectUID, $routeParams.adesioneUID, 'H', code)
                .then(function (data) {
                    $('#loadingModal').modal('hide');
                    if (data && data.url) {

                        var url = data.url;
                        var name = 'Allegato' + code + '_UID' + $routeParams.adesioneUID + '.pdf';

                        window.open(url, name);
                        switch (code) {
                            case '2':
                                return vm.linkPDFAll2 = data.url;
                        }
                    } else
                        return true;
                });
        }

        //*******************************
        // Print PDF RICEVUTA
        function printRicevuta() {
            if (vm.record.Sent) {
                $('#loadingModal').modal('show');
                return datacontext.pdf_printRicevuta($routeParams.projectUID, $routeParams.adesioneUID, 'H')
                    .then(function (data) {
                        $('#loadingModal').modal('hide');
                        if (data && data.url) {

                            var url = data.url;
                            var name = 'Ricevuta_UID' + $routeParams.adesioneUID + '.pdf';

                            window.open(url, name);

                            getRecordByUID($routeParams.adesioneUID);
                            return vm.linkPDFRicevuta = data.url;
                        } else
                            return true;
                    });
            }
        }

        //=====================================


        function setRecord(data) {
            vm.record = data;
            if (vm.record.Deleted || vm.record.Annulled) {
                vm.errorAccess = 'linkError';
                return;
            }

            //Reset campi Notifiche
            vm.validCF = true;

            if (vm.record.Completed)
                return;

            checkCF(vm.record.CodiceFiscale);
            searchCF(vm.record.CodiceFiscale);

            //Abilita questo codice solo per sistemazioni grafiche della comunicazione Link di Accesso
            vm.isVisibleLinkDomanda = true;

            if (vm.record.NascData != null) vm.record.NascData = new Date(vm.record.NascData);
            if (vm.record.DtIscrittoCPI != null) vm.record.DtIscrittoCPI = new Date(vm.record.DtIscrittoCPI);
            if (vm.record.Email != null) vm.confirm.Email = vm.record.Email;
            if (vm.record.NascPaeseId == '' || vm.record.NascPaeseId == null) vm.record.NascPaeseId = 0;
            if (vm.record.ResPaeseId == '' || vm.record.ResPaeseId == null) vm.record.ResPaeseId = 0;

            //Ricarico i valori
            changeComune('nasc', vm.record.NascProvinciaId);
            changeComune('res', vm.record.ResProvinciaId);
            if (vm.record.DomUgualeRes > 0) {
                if (vm.record.DomPaeseId == '' || vm.record.DomPaeseId == null) vm.record.DomPaeseId = 0;
                changeComune('res', vm.record.ResProvinciaId);
            }
            getAllPSede(vm.record.PartecipazioneId);
        }

        function showAlertDivs(errorAccess) {
            var msg = '';

            vm.errorAccess = errorAccess;

            if (errorAccess == 'linkError') {
                msg = 'Attenzione! Il link utilizzato e\' errato.';
            }

            if (msg != '') return logError(msg);

            return false;
        }

        function getRecordByUID(uid) {
            console.info('getRecordByUID()', uid);
            return datacontext.cndAdesione_getByUID(uid, $routeParams.projectUID).then(function (data) {
                console.info('data', data);
                if (data == null || $.isNumeric(data) || data.Id == 0) {
                    showAlertDivs('linkError');
                    return false;
                }
                //Riduco il pannello con le modalit� di utilizzo dello strumento
                vm.showInfoMsg = false;

                setRecord(data); //vm.record = data; 
                setStepDefault();
                vm.record.ProgettoUId = $routeParams.projectUID;
            });
        }


        function addRecord(id) {
            return datacontext.cndAdesione_get(id).then(function (data) {
                vm.records.push(data);
                vm.countRecords++;
            });
        }

        //Sistemo i campi che ho resettato prima di mandarli al controller
        function unResetItem(item) {
            if (item.DomUgualeRes == 0) {
                item.DomPaeseId = 0;
                item.DomProvinciaId = 0;
                item.DomComuneId = 0;
                item.DomTIndirizzoId = 0;
                item.DomIndirizzo = '';
                item.DomCivico = '';
                item.DomCap = '';
            }

            if (item.NascPaeseId > 0) {
                item.NascProvinciaId = 0;
                item.NascComuneId = 0;
            }

            if (item.ResPaeseId > 0) {
                item.ResProvinciaId = 0;
                item.ResComuneId = 0;
            }

            if (item.DomPaeseId > 0) {
                item.DomProvinciaId = 0;
                item.DomComuneId = 0;
            }
        }
        function saveOrUpdateItem() {
            unResetItem(vm.record);
            if (vm.record == null || vm.record.Id == 0) {
                bDialog.confirmationDialog('Attenzione', 'Dopo il primo salvataggio non sar\xE0 pi\xF9 possibile modificare il campo "CODICE FISCALE". Procedere?', 'OK').then(
                    function () { //YES
                        //Parametro di appoggio per send_Email
                        vm.record.ProgettoUId = $routeParams.projectUID;
                        $('#loadingModal').modal('show');
                        return datacontext.cndAdesione_add(vm.record).then(function (data) {
                            $('#loadingModal').modal('hide');
                            if (data == "409") {
                                logError('Errore: codice fiscale esistente. ');
                                return data;
                            }
                            if (data == "304") {
                                logError('Attenzione "BANDO SCADUTO". Modifica dati non permessa. ');
                                return data;
                            }
                            if (data == "417") {
                                logError('Errore: importo ISEE oltre il valore consentito ');
                                return data;
                            }
                            if (data == "501") {
                                logError('Errore: codice fiscale non valido. Si verifichino i campi corrispondenti ');
                                return data;
                            }
                            if ($.isNumeric(data)) {
                                logError('Errore non specificato. Impossibile registrare i dati inseriti.');
                                return data;
                            }

                            if (data) {
                                setRecord(data); //vm.record = data;

                                $routeParams.adesioneUID = vm.record.UID;
                                //getListAttach(vm.record.Id);

                                if (vm.record.Id > 0) {
                                    //Riduco il pannello con le modalit� di utilizzo dello strumento
                                    vm.showInfoMsg = false;
                                }

                                return logSuccess('E\' stata inviata una email all\'indirizzo ' + vm.record.Email + ' con i dati inseriti. ');
                            }
                        });
                    },
                    function () { //NO
                        vm.loading = false;
                    }
                );
            }
            else {
                if (vm.record.IscrittoCPI && (vm.record.CPIId == 0 || vm.record.CPIId == null || vm.record.DtIscrittoCPI == '' || vm.record.DtIscrittoCPI == null)) {
                    return bDialog.informationDialog('Bisogna compilare il centro per l\'impiego e/o la data di iscrizione');
                }

                $('#loadingModal').modal('show');
                return datacontext.cndAdesione_update(vm.record).then(function (data) {
                    $('#loadingModal').modal('hide');
                    if (data == "409") {
                        logError('Errore: codice fiscale esistente. ');
                        return data;
                    }
                    if (data == "403") {
                        logError("Attenzione dati mancanti. ");
                        return data;
                    }
                    if (data == "304") {
                        logError('Attenzione "BANDO SCADUTO". Modifica dati non permessa. ');
                        return data;
                    }
                    if (data == "406") {
                        logError("Attenzione mancano alcuni allegati, inserirli prima di effettuare la trasmissione. ");
                        return data;
                    }
                    if (data == "417") {
                        logError('Errore: importo ISEE oltre il valore consentito ');
                        return data;
                    }
                    if ($.isNumeric(data)) {
                        logError('Errore non specificato. Impossibile registrare i dati inseriti.');
                        return data;
                    }

                    if (data) {
                        setRecord(data); //vm.record = data;
                        $routeParams.adesioneUID = vm.record.UID;
                        logSuccess('Dati salvati');
                        return true;
                    }
                });
            }
        }



        function deleteItem(item) {
            var msg = ' la domanda di adesione di : ' + item.CodiceFiscale;
            bDialog.deleteDialog(msg).then(function () {
                return datacontext.cndAdesione_delete(item.Id).then(function (data) {
                    if (data != "204") return logError('Errore cancellazione dati [' + data + ']');

                    var index = vm.records.indexOf(item)
                    vm.records.splice(index, 1);
                    vm.countRecords--;
                });
            });
        }


        //**********************************************************************
        //GESTIONE ATTACH 2

        function populateAttach() {
            vm.ades_ref = '';
            if (vm.record != undefined && vm.record.Id != 0 && vm.record.Id != undefined) {
                vm.ades_ref = vm.record.Cognome + ' ' + vm.record.Nome + ' (' + vm.record.CodiceFiscale + ')';
                return getListAttach().then(function () {
                    return true;
                });
            }
        }

        function getListAttach() {
            vm.list.attach_ades = [];
            return datacontext.attach_getAllCND(0, 0, $routeParams.projectUID, $routeParams.adesioneUID, vm.record.Id, 0, vm.tSourceCode_ADES, undefined, 0, 0, '', vm.fAttach.TAttachId, '').then(function (data_ATT) {
                vm.list.b_attach = true;
                if (!$.isNumeric(data_ATT)) vm.list.attach_ades = data_ATT;

                return datacontext.tAttach_getAll(0, 0, vm.tSourceCode_ADES, 0, '', 0, '').then(function (data_TA) {
                    vm.tAttach_Needed = data_TA;

                    return datacontext.tAttachVisibility_getAll(0, 0, vm.tSourceCode_ADES).then(function (data_TAV) {
                        var tAttVis = data_TAV;

                        vm.tAttach_Needed.forEach(function (item_TA) {
                            console.info('item_TA', item_TA);
                            var att = {};
                            att.TAttachId = item_TA.Id;
                            att.TAttach = item_TA.sName;

                            if (typeof (vm.list.attach_ades) == 'undefined') vm.list.attach_ades = [];
                            var myrec = _.find(vm.list.attach_ades, { 'TAttachId': item_TA.Id });
                            var myTAV = _.find(tAttVis, { 'TAttachId': item_TA.Id });

                            if (typeof (myTAV) == 'undefined') {
                                myTAV = {};
                                myTAV.bRead = true;
                                myTAV.bInsert = true;
                                myTAV.bUpdate = true;
                                myTAV.bDelete = true;
                                myTAV.iTags = 0;
                            }

                            att.bRead = myTAV.bRead;
                            att.bInsert = myTAV.bInsert;
                            att.bUpdate = myTAV.bUpdate;
                            att.bDelete = myTAV.bDelete;
                            att.iTags = myTAV.iTags;

                            if (typeof (myrec) == 'undefined') {
                                if (att.bRead)
                                    vm.list.attach_ades.push(att);
                            }
                            else {
                                myrec.bRead = myTAV.bRead;
                                myrec.bInsert = myTAV.bInsert;
                                myrec.bUpdate = myTAV.bUpdate;
                                myrec.bDelete = myTAV.bDelete;
                                myrec.iTags = myTAV.iTags;

                                var items = _.groupBy(vm.list.attach_ades, { 'TAttachId': item_TA.Id });

                                items.true.forEach(function (i) {
                                    i.bRead = myTAV.bRead;
                                    i.bInsert = myTAV.bInsert;
                                    i.bUpdate = myTAV.bUpdate;
                                    i.bDelete = myTAV.bDelete;
                                    i.iTags = myTAV.iTags;
                                });

                                if (myrec.bInsert) {
                                    if (item_TA.MaxValue == 99 || item_TA.MaxValue > items.true.length)
                                        vm.list.attach_ades.push(att);
                                }
                            }
                        });
                        return vm.list.attach_ades;
                    });
                });
            });
        }

        function getTAttachNeeded(code) {
            if (!code) return;
            return datacontext.tAttach_getAll(0, 0, code, 0, '', 0, '').then(function (data) {
                return vm.tAttach_Needed = data;
            });
        }

        function getExtractP7MFile(id) {
            return datacontext.attach_extract(id).then(function (data) {
                if (data == "ERR01") return logError("Errore: il documento non \xE8 un documento 'P7M' valido. ");
                if (data == "ERR02") return logError("Errore: documento non trovato. ");
                if (data == "ERR03") return logError("Errore: il documento non ha firma digitale. ");

                var url = data;
                window.open(url, 'Download');
            });
        }

        function getExtractP7MInfo(id) {
            var fileName = "";
            return datacontext.attach_extractP7MInfo(id).then(function (data) {
                fileName = data;

                common.$http.get('/api/pdf/GetP7mVerify?id=' + id, { responseType: 'arraybuffer' })
                    .then(function (response) {
                        if (response.status == 204) {

                            logError('Il documento non ha Firma Digitale');
                            return;
                        }

                        var file = new Blob([response.data], { type: 'application/pdf' });
                        var fileURL = URL.createObjectURL(file);
                        fileName = fileName.substring(0, fileName.indexOf('.'));

                        window.open(fileURL, fileName);

                        //var a = document.createElement("a");
                        //a.setAttribute('style', 'display:none');
                        //document.body.appendChild(a);                        
                        //a.href = fileURL
                        //if ($rootScope.detectIE())
                        //    window.navigator.msSaveBlob(file, 'VerificaFirma_' + fileName + '.pdf');
                        //else
                        //    a.download = 'VerificaFirma_' + fileName + '.pdf';
                        //a.click();
                        //document.body.removeChild(a);
                    })
                    .catch(function (message) {
                        logError('Impossibile scaricare il file');
                    });

            });

        }

        // DELETE ATTACH2
        function deleteAttach(item) {
            if (item == undefined) return;

            var msg = ' Allegato ' + item.Name;
            bDialog.deleteDialog(msg).then(function () {
                return datacontext.attach_delete(item.Id).then(function (data) {
                    if (data == "400") return logError('Attenzione: allegato non cancellabile! Contattare l\'Help-desk');
                    if (data == "417") return bDialog.errorDialog('Attenzione: azione non permessa, perch\xE8 entit\xE0 bloccata in cascata da altri elementi. ');

                    //Popolo l'oggetto att da cancellare
                    var index = vm.list.attach_ades.indexOf(item)
                    var att = {};
                    att.TAttachId = vm.list.attach_ades[index].TAttachId;
                    att.TAttach = vm.list.attach_ades[index].TAttach;

                    return datacontext.tAttachVisibility_getAll(0, 0, vm.tSourceCode_ADES).then(function (data_TAV) {
                        var tAttVis = data_TAV;

                        var myTAV = _.find(tAttVis, { 'TAttachId': att.TAttachId });

                        if (typeof (myTAV) == 'undefined') {
                            myTAV = {};
                            myTAV.bRead = true;
                            myTAV.bInsert = true;
                            myTAV.bUpdate = true;
                            myTAV.bDelete = true;
                            myTAV.iTags = 0;
                        }

                        att.bRead = myTAV.bRead;
                        att.bInsert = myTAV.bInsert;
                        att.bUpdate = myTAV.bUpdate;
                        att.bDelete = myTAV.bDelete;
                        att.iTags = myTAV.iTags;

                        //Individuo la tipologia corrispondente
                        var item_TA = _.find(vm.tAttach_Needed, { 'Id': att.TAttachId });
                        //Raggruppo la lista per tipologia
                        var items = _.groupBy(vm.list.attach_ades, { 'TAttachId': att.TAttachId });

                        //Se ho un allegato per la tipologia
                        if (items.true.length == 1 || item_TA.MaxValue == items.true.length) {
                            vm.list.attach_ades[index] = att; //Ripulisco il record
                        }
                        else if (item_TA.MaxValue > items.true.length) {
                            //Rimuovo l'oggetto
                            vm.list.attach_ades.splice(index, 1);
                        }
                    });
                });
            });
        }


        // ADD ATTACH2
        function addAttach(tAttachId) {
            var recTSource = {};
            var recSource = {};

            if (vm.record != undefined && vm.record.Id != undefined && vm.record.Id != 0) {
                recTSource = { Id: vm.tSource.Id, Name: vm.tSource.Name };
                recSource = { Id: vm.record.Id, Name: vm.ades_ref };

                var modalInstance = modal.open({
                    templateUrl: '/app/ATT/attach/modal/attachAdd2.html?version=127',
                    controller: 'attachAdd2',
                    backdrop: 'static',
                    resolve: {
                        tSource: function () {
                            return [recTSource];
                        },
                        tSourceCode: function () {
                            return vm.tSource.Code;
                        },
                        tSourceId: function () {
                            return vm.tSource.Id;
                        },
                        source: function () {
                            return [recSource];
                        },
                        sourceId: function () {
                            return recSource.Id;
                        },
                        tAttach: function () {
                            return vm.tAttach_Needed;
                        },
                        tAttachId: function () {
                            return tAttachId;
                        }
                    }
                });

                modalInstance.result.then(function (returnItem) {
                    if (returnItem == "406") return logError('Errore: tipologia di allegato non permessa! ');
                    if (returnItem == "400") return logError('Errore registrazione dati');

                    logSuccess('Dato salvato con successo! ');
                    populateAttach();
                }, function () {
                    //log('Modal dismissed at: ' + new Date());
                });

                return true;
            } else return;
        };

        //************************END*****************************



        //Elenchi Parametri
        function getTSource(code) {
            if (!code) return;

            return datacontext.tSource_getByCode(code).then(function (data) {
                return vm.tSource = data;
            });
        }

        function getTAttach(code) {
            if (!code) return;

            return datacontext.tAttach_getAllList(code, 0, 0, 0).then(function (data) {
                return vm.tAttach = data;
            });
        }

        /*********************/
        // Gestione parametrica Paesi, province, tIndirizzi, Comuni

        function getAllPartecipazioni() {
            if (vm.cmblist.partecipazioni.length > 0) return;

            datacontext.cndAdesione_getAllPartecipazione('AZD_FORM-FAM1').then(function (data) {
                vm.cmblist.partecipazioni = data;
            });
        }

        function getAllPSede(partecipazioneId) {
            vm.list.pSedi = [];
            if (partecipazioneId == 0) return;
            return datacontext.cndAdesione_getAllPsede(partecipazioneId).then(function (data) {
                return vm.list.pSedi = data;
            });
        }

        function changePartecipazione() {
            if (vm.record.PartecipazioneId > 0) {
                getAllPSede(vm.record.PartecipazioneId);
                var part = _.find(vm.cmblist.partecipazioni, { 'Id': vm.record.PartecipazioneId });
                console.info('part', part);
                if (part != null) {
                    vm.record.SoggettoCode = part.TRuoloCode;
                    vm.record.SoggettoId = part.APLId;
                    vm.record.Soggetto = part.RagioneSociale;
                    vm.record.SoggettoCF = part.CodiceFiscale;
                }
            }
            else {
                vm.record.SoggettoCode = '';
                vm.record.SoggettoId = 0;
                vm.record.Soggetto = '';
                vm.record.SoggettoCF = '';
                vm.record.PSedeId = 0;
                vm.list.pSedi = [];
            }
        }

        function getCPI() {
            if (vm.cmblist.cpi.length > 0) return;

            datacontext.cndAdesione_getListCPI().then(function (data) {
                vm.cmblist.cpi = data;
            });
        }
        function getCittadinanze() {
            if (vm.cmblist.cittadinanze.length > 0) return;

            datacontext.arrCittadinanze().then(function (data) {
                vm.cmblist.cittadinanze = data;
            });
        }

        function getPaesi() {
            if (vm.cmblist.paesi.length > 0) return;
            datacontext.arrPaesi().then(function (data) {
                vm.cmblist.paesi = jQuery.extend([], data);
            });
        }

        function getProvince() {
            if (vm.cmblist.province.length > 0) return;
            datacontext.arrProvince().then(function (data) {
                vm.cmblist.province = jQuery.extend([], data);
            });
        }

        function getTIndirizzi() {
            if (vm.cmblist.tIndirizzi.length > 0) return;
            datacontext.arrTIndirizzo().then(function (data) {
                vm.cmblist.tIndirizzi = jQuery.extend([], data);
            });
        }

        function changePaese(code) {
            switch (code) {
                case 'nasc':
                    if (vm.record.NascPaeseId > 0) {
                        vm.record.NascProvinciaId = 0;
                        changeProvincia(0);
                    }

                    if (vm.record.NascPaeseId == 0) {
                        vm.record.Cittadinanza1Id = 1;
                    }
                    break;
                case 'res':
                    if (vm.record.ResPaeseId > 0) {
                        vm.record.ResProvinciaId = 0;
                        changeProvincia(0);
                    }
                    break;
                case 'dom':
                    if (vm.record.DomPaeseId > 0) {
                        vm.record.DomProvinciaId = 0;
                        changeProvincia(0);
                    }
                    break;
            }
        }
        function changeProvincia(code, idprov) {
            switch (code) {
                case 'nasc':
                    vm.record.NascComuneId = 0;
                    changeComune(code, idprov);
                    break;
                case 'res':
                    vm.record.ResComuneId = 0;
                    changeComune(code, idprov);
                    break;
                case 'dom':
                    vm.record.DomComuneId = 0;
                    changeComune(code, idprov);
                    break;
            }
        }
        function changeComune(code, idprov) {
            switch (code) {
                case 'nasc':
                    if (!idprov || idprov == 0) {
                        return vm.cmblist.comuniNasc = [];
                    }
                    if (vm.record.NascProvinciaId != idprov) vm.cmblist.comuniNasc = [];
                    return datacontext.istat_comune_getAllList(idprov).then(function (data) {
                        return vm.cmblist.comuniNasc = data;
                    });
                    break;
                case 'res':
                    if (!idprov || idprov == 0) {
                        return vm.cmblist.comuniRes = [];
                    }
                    if (vm.record.ResProvinciaId != idprov) vm.cmblist.comuniRes = [];
                    return datacontext.istat_comune_getAllList(idprov).then(function (data) {
                        return vm.cmblist.comuniRes = data;
                    });
                    break;
                case 'dom':
                    if (!idprov || idprov == 0) {
                        return vm.cmblist.comuniDom = [];
                    }
                    if (vm.record.DomProvinciaId != idprov) vm.cmblist.comuniDom = [];
                    return datacontext.istat_comune_getAllList(idprov).then(function (data) {
                        return vm.cmblist.comuniDom = data;
                    });
                    break;
            }
        }

        function changeDomUgualeRes() {
            if (vm.record.DomUgualeRes == 0) {
                vm.record.DomPaeseId = '';
                vm.record.DomProvinciaId = '';
                vm.record.DomComuneId = '';
                vm.record.DomTIndirizzoId = '';
                vm.record.DomIndirizzo = '';
                vm.record.DomCivico = '';
                vm.record.DomCap = '';
            }
            else {
                vm.record.DomPaeseId = 0; //ITALIA
                vm.record.DomTIndirizzoId = 1;
            }
        }

        function changeIscrittoCPI() {
            if (!vm.record.IscrittoCPI) {
                vm.record.CPIId = 0;
                vm.record.DtIscrittoCPI = '';
            }
        }

        // END
        /*************/




        //Metodi interfaccia Filtri
        function setfAttach() {
            if (vm.checkfAttach == false) {
                vm.fAttach.TAttachId = '';
            }
        }



        //****************************************************
        // OPEN MODAL DIALOG
        //****************************************************
        function addModal() {

        };

        //#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-VERIFICA DEI PRE-REQUISITI P4 CON LEP E -#-#-#-#-#-#
        vm.ddChecked = false;
        vm.showReq = false;
        vm.checkCF = checkCF;
        function checkCF(value) {
            //console.log('searchCF()');
            vm.ddChecked = false;
            vm.showReq = false;
            if (value == undefined) return;
            if (value.length != 16) return; //numero minimo di caratteri            
            return datacontext.cndAdesione_status(value).then(function (data) {
                vm.showReq = true;
                vm.ddChecked = data;
            });
        }


        //#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-EXISTS DomandaAdesione FOR CF -#-#-#-#-#-#
        vm.existCF = false;
        vm.searchCF = searchCF;
        function searchCF(value) {
            //console.log('searchCF()');
            if (value == undefined) return;
            if (value.length != 16) return; //numero minimo di caratteri
            vm.existCF = false;
            return datacontext.cndAdesione_exists(vm.record.Id, value).then(function (data) {
                vm.existCF = data;
            });
        }

        //#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#- VALID CODICE FISCALE -#-#-#-#-#-#
        vm.validCF = true;
        vm.getValidCF = getValidCF;
        function getValidCF(value) {
            var requiredLen = 16;
            if (value == undefined) return;
            if (value.length != requiredLen) return; //numero minimo di caratteri
            vm.validCF = false;
            return datacontext.validazione_cf(value, false).then(function (data) {
                return vm.validCF = data;
            });
        }

        //#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#- VALID FIELDS CODICE FISCALE -#-#-#-#-#-#
        vm.validFieldsCF = true;
        vm.getValidFieldsCF = getValidFieldsCF;
        function getValidFieldsCF() {
            if (vm.record.CodiceFiscale == undefined) return;
            if (vm.record.CodiceFiscale.length != 16) return; //numero minimo di caratteri
            if (vm.record.Nome == undefined) return;
            if (vm.record.Cognome == undefined) return;
            if (vm.record.Sesso == undefined) return;
            if (vm.record.NascPaeseId == 0 && (vm.record.NascComuneId == undefined || vm.record.NascComuneId == 0)) return;
            if (vm.record.NascData == undefined || vm.record.NascData == '') return;
            var strDtNasc = common.dateToString(vm.record.NascData); //la data deve avere formato dd/MM/yyyy
            vm.validFieldsCF = false;
            return datacontext.validazione_fieldsCF(vm.record.CodiceFiscale, vm.record.Nome, vm.record.Cognome, vm.record.Sesso, strDtNasc, vm.record.NascPaeseId, vm.record.NascComuneId).then(function (data) {
                return vm.validFieldsCF = data;
            });
        }

        //#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#- VALID IBAN -#-#-#-#-#-#
        vm.validIBAN = true;
        vm.getValidIBAN = getValidIBAN;
        function getValidIBAN(value) {
            var requiredLen = 27;
            if (value == undefined) return;
            if (value.length != requiredLen) return; //numero minimo di caratteri
            vm.validIBAN = false;
            return datacontext.validazione_iban(value).then(function (data) {
                return vm.validIBAN = data;
            });
        }



    }
})();
